'use strict';

import {addClass} from '../helpers';

export const prlxBlocks = (() => {
  let _parallaxes;
  let koef = 1.8;
  const accur = 10 ** 3; // 2 знака после запятой

  const eventListeners = () => {
    window.addEventListener("resize", function() {
      seeHeight();
    });
  };

  const seeHeight = () => {
    _parallaxes.forEach((_el, index) => {
      const _img = _el.querySelector('img');
      if (!_img) return;
      if (_el.getAttribute('data-koef')) koef = parseFloat(_el.getAttribute('data-koef'));

      const setHeight = () => {
        // console.log(_img.getAttribute('src'));
        _el.style['height'] = '';
        const heightImg = _img.height;
        // console.log('heightImg - ', heightImg);
        const heightWrap = Math.round(heightImg / koef);
        // console.log('heightWrap - ', heightWrap);
        const diff = Math.round(heightWrap / heightImg * 100 * accur - 100 * accur) / accur;
        _el.setAttribute('data-scroll-parallax', diff);
        _el.style['height'] = `${heightWrap}px`;
      };

      _img.onload = setTimeout(() => {
        setHeight();
      }, 300);
      // setHeight();
    })
  };

  const init = () => {
    _parallaxes = document.querySelectorAll('[data-scroll-parallax]');
    if (!_parallaxes.length) {
      return false;
    }

    window.shApp.resetPrlx = seeHeight;
    eventListeners();
    addClass(_parallaxes, 'is-loading');

    seeHeight();
  };

  return {
    init
  }
})();
